"use client"

import { useEffect, useState } from "react"
import { MdWifiOff } from "react-icons/md"

export function OfflineBanner() {
  const [isOnline, setIsOnline] = useState(true)
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
    setIsOnline(navigator.onLine)
    const handleOnline = () => setIsOnline(true)
    const handleOffline = () => setIsOnline(false)
    window.addEventListener("online", handleOnline)
    window.addEventListener("offline", handleOffline)
    return () => {
      window.removeEventListener("online", handleOnline)
      window.removeEventListener("offline", handleOffline)
    }
  }, [])

  if (!mounted || isOnline) return null

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-amber-600 text-white text-sm py-1.5 px-4 flex items-center justify-center gap-2">
      <MdWifiOff size={16} />
      You are offline — browsing cached content
    </div>
  )
}
